import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';

import {
  ToolbarModule,
  TabsModule,
  FilterModule,
  PaginationModule,
  SettingsModule,
  TableModule,
} from 'beyond-util';
import { KurseviComponent } from './kursevi.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    PaginationModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
    NgxSpinnerModule,
  ],
  declarations: [KurseviComponent],
  entryComponents: [KurseviComponent],
  exports: [KurseviComponent],
  providers: [],
})
export class KurseviModule {}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/kursevi/kursevi.module.ts